export default {
  UPDATE_TASK_REQUEST: 'TaskConstants.UPDATE_TASK_REQUEST',
  UPDATE_TASK_SUCCESS: 'TaskConstants.UPDATE_TASK_SUCCESS',
  UPDATE_TASK_FAILURE: 'TaskConstants.UPDATE_TASK_FAILURE',
  UPDATE_TASK_FULFILLED: 'TaskConstants.UPDATE_TASK_FULFILLED',
};
